/*
 * Admin area to edit cancel action button labels.  Each set of labels per touchpoint is shown as a list.
 */

define([
  "marionette",
  "underscore",
  "messaging/messenger",
  "./cancelActionLabelDisplayView",
], function (Marionette, _, Messenger, CancelActionLabelDisplayView) {
  var CancelActionLabelDisplayController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "cancelActionLabelDisplay";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (touchPointId) {
      this.cancelActionLabels = Messenger.reqres.request("cancelAction:labels", touchPointId);

      Messenger.onSave(function () {
        this.cancelActionLabels.saveCollection();
      }, this);

      this.cancelActionLabels.onSynced(function () {
        this.view = new CancelActionLabelDisplayView.cancelActionLabels({
          collection: this.cancelActionLabels,
        });
        this.showRegion(this.view);
      }, this);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "change:selected:touchPoint",
        function (newTouchPointId) {
          this.cancelActionLabels.onSynced(function () {
            this.show(newTouchPointId);
          }, this);
        },
        this,
      );
    },
  });

  return CancelActionLabelDisplayController;
});
